<template>
    <div>
        <img class="loading-policy overlay-loader" v-show="startLoading" src="../assets/images/iris_spinner.gif" alt="Loading Spinner">
        <div class="passValidationCont">

            <div v-if="minLengthShow">
                <span v-bind:class="isMinLengthSatisfied ? 'glyph-icon-ok' : 'glyph-icon-remove'" id="minLength" class="glyph-icon"></span>
                <span> Use at least {{minLengthVal}} characters</span>
            </div>

            <div v-if="maxLengthShow">
                <span v-bind:class="isMaxLengthSatisfied ? 'glyph-icon-ok' : 'glyph-icon-remove'" id="maxLength" class="glyph-icon"></span>
                <span> Use at most {{maxLengthVal}} characters</span>
            </div>

            <div v-if="minUpperShow">
                <span id="minUpper" v-bind:class="isMinUpperSatisfied ? 'glyph-icon-ok' : 'glyph-icon-remove'" class="glyph-icon"></span>
                <span> Capital letter</span>
            </div>

            <div v-if="minLowerShow">
                <span v-bind:class="isMinLowerSatisfied ? 'glyph-icon-ok' : 'glyph-icon-remove'" id="minLower" class="glyph-icon"></span>
                <span> Lowercase letter</span>
            </div>

            <div v-if="minNumericShow">
                <span v-bind:class="isMinNumericSatisfied ? 'glyph-icon-ok' : 'glyph-icon-remove'" id="minNumeric" class="glyph-icon"></span>
                <span> Number</span>
            </div>

            <div v-if="minSpecialShow">
                <span v-bind:class="isMinSpecialSatisfied ? 'glyph-icon-ok' : 'glyph-icon-remove'" id="minSpecial" class="glyph-icon"></span>
                <span> Special Character</span>
            </div>
        </div>
        <div class="newPassSubHeader">And please remember</div>
        <div class="passValidationSubCont">
            <div>
                <span>{{reUseText}}</span>
            </div>

            <div>
                <span>You cannot change your password more than once in the same day</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "password-validation",
        props: {
            domain:String,
            newPwdValue: String,
            policy:Object
        },
        data() {
            return {
                minLengthShow: false,
                maxLengthShow: false,
                minLowerShow: false,
                minUpperShow: false,
                minNumericShow: false,
                minSpecialShow: false,
                minLengthVal: 0,
                maxLengthVal: 0,
                isMinLengthSatisfied: false,
                isMaxLengthSatisfied: false,
                isMinLowerSatisfied: false,
                isMinUpperSatisfied: false,
                isMinNumericSatisfied: false,
                isMinSpecialSatisfied: false,
                startLoading: true
            };
        },
        computed:{
            reUseText() {
                return "Do not re-use any of your last 5 passwords";
            }
        },
        watch: {
            newPwdValue: {
                handler: "onHandleValidation",
                immediate: true
            },
            policy: {
                handler: "onHandleValidation",
                immediate: true
            }
        },
        methods: {
            onHandleValidation() {
                if (this.policy) {
                    this.startLoading = false;
                    if (this.newPwdValue != null) {
                        this.minLengthShow = this.policy.minLength > 0;
                        this.maxLengthShow = this.policy.maxLength > 0;
                        this.minLowerShow = this.policy.minLowerCase > 0;
                        this.minUpperShow = this.policy.minUpperCase > 0;
                        this.minNumericShow = this.policy.minNumeric > 0;
                        this.minSpecialShow = this.policy.minSpecialChar > 0;
                        this.minLengthVal = this.policy.minLength;
                        this.maxLengthVal = this.policy.maxLength;
                        let anyNotSatisfied = false;
                        let data = this.policy;
                        if (this.minLengthShow) {
                            this.isMinLengthSatisfied = (this.newPwdValue.length < data.minLength) ? false : true;
                            if (!this.isMinLengthSatisfied)
                                anyNotSatisfied = true;
                        }

                        if (this.maxLengthShow) {
                            this.isMaxLengthSatisfied = (this.newPwdValue.length > 0 && !(this.newPwdValue.length > data.maxLength)) ? true : false;
                            if (!this.isMaxLengthSatisfied)
                                anyNotSatisfied = true;
                        }

                        if (this.minLowerShow) {
                            let numberLcase = this.newPwdValue.replace(/[^a-z]/g, "").length;
                            this.isMinLowerSatisfied = (!(numberLcase < data.minLowerCase)) ? true : false;
                            if (!this.isMinLowerSatisfied)
                                anyNotSatisfied = true;
                        }

                        // Min Upper
                        if (this.minUpperShow) {
                            let numberUcase = this.newPwdValue.replace(/[^A-Z]/g, "").length;
                            this.isMinUpperSatisfied = (!(numberUcase < data.minUpperCase)) ? true : false;
                            if (!this.isMinUpperSatisfied)
                                anyNotSatisfied = true;
                        }

                        if (this.minNumericShow) {
                            let numbers = this.newPwdValue.replace(/[^0-9]/g, "").length;
                            this.isMinNumericSatisfied = (!(numbers < data.minNumeric)) ? true : false;
                            if (!this.isMinNumericSatisfied)
                                anyNotSatisfied = true;
                        }

                        if (this.minSpecialShow) {
                            let special = 0;
                            for (let i = 0; i < this.newPwdValue.length; i++) {
                                let charAt = this.newPwdValue.charCodeAt(i);
                                if (charAt >= 33 && charAt <= 47 || charAt === 64) {
                                    special++;
                                }
                            }
                            this.isMinSpecialSatisfied = (!(special < data.minSpecialChar)) ? true : false;
                            if (!this.isMinSpecialSatisfied)
                                anyNotSatisfied = true;
                        }
                        this.$emit('passwordPolicyValidated', !anyNotSatisfied);
                    } else {
                        this.$emit('passwordPolicyValidated', false);
                    }
                }
            }
        }
    }

</script>

<style scoped>
    .loading-policy {
        top: 40% !important;
        width:50px !important;
        margin-top: 10%;
        margin-left: 35%;
    }
    .passValidationCont {
        padding: 18px 15px;
    }

    .passValidationSubCont {
        color: #666;
        padding: 8px 15px;
        font-size: 14px;
    }

    .newPassSubHeader {
        background: none;
        padding: 20px 15px 0px 15px;
        color: #000000 !important;
        font-size: 14px;
        font-weight: bold;
        border-top: 1px solid #eee;
    }
    .glyph-icon{
        height: 20px;
        width: 20px;
        margin-right: 6px;
        display: block;
        float: left;
    }
    span.glyph-icon{
        color: transparent;
    }
    .passValidationCont div, .newPassMessage .passValidationSubCont div{
        padding: 5px 0px;
        line-height: 20px;
    }
    span.glyph-icon{
        color: transparent;
    }
    .glyph-icon.glyph-icon-ok{
        background: url(../assets/images/pass-ok.png) no-repeat center center;
    }

    .glyph-icon.glyph-icon-remove{
        background: url(../assets/images/pass-error.png) no-repeat center center;
    }
</style>